export default __webpack_public_path__ + "static/media/Group 397.73091431.svg";